import { useNavigate } from "react-router-dom";
import { FormularzAnalizy } from "../../components/analiza/FormularzAnalizy.js";

/**
 * "Nowa rozmowa" konta `user` (trasa /nowa): formularz w wariancie uzytkownika (karty "Skąd jest rozmowa?", "Kim jesteś
 * w tej rozmowie?" i zgoda z przyciskiem "Oceń rozmowę"). Po przyjeciu rozmowy przez serwer przechodzimy od razu na jej
 * ekran (/analizy/<id>), gdzie widac postep, a potem wynik: uzytkownik nie ma ogladac listy w oczekiwaniu na swoja rozmowe.
 *
 * Bez odpowiedzi przyjecia (nagranie dotarlo, ale serwer nie potwierdzil) zostajemy na formularzu: jego komunikat odsyla
 * do listy "Moje rozmowy", bo analiza mogla juz powstac.
 */
export function NowaRozmowaPage(): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <>
      <h1 className="page-title">Nowa rozmowa</h1>
      <p className="page-lead">Odpowiedz na dwa proste pytania, a resztą zajmiemy się my.</p>
      <FormularzAnalizy
        wariant="uzytkownik"
        onWgrano={(odpowiedz) => {
          if (odpowiedz) navigate(`/analizy/${encodeURIComponent(odpowiedz.id)}`);
        }}
      />
    </>
  );
}
